"use client";
import * as React from "react";
const SvgVisibilityOnRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 .54A8.6 8.6 0 0 0 0 6a8.6 8.6 0 0 0 16 0A8.6 8.6 0 0 0 8 .54m0 9.09a3.64 3.64 0 0 1-3.64-3.64A3.64 3.64 0 0 1 8 2.36 3.64 3.64 0 0 1 11.64 6 3.64 3.64 0 0 1 8 9.63m0-5.82A2.2 2.2 0 0 0 5.82 6c0 1.2.97 2.18 2.18 2.18A2.2 2.2 0 0 0 10.18 6 2.2 2.2 0 0 0 8 3.8" }));
export {
  SvgVisibilityOnRound as default
};
